module.exports = Studio.libraries['react'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['react']"
 ** module id = 1
 ** module chunks = 0
 **/